<template>
  <section class="block-offer offer">
    <div class="container">
      <h2 class="offer__title">
        Специальное предложение<br />
        от Ауди Центра Север
      </h2>
      <p class="offer__subtitle">
        Специальное предложение от Ауди Центра Север
      </p>
      <ul class="offer__list">
        <li class="offer__list-item" v-for="(item, i) in offer_list" :key="i">
          <p>{{ item.title }}</p>
          <h4>{{ item.value }}</h4>
        </li>
      </ul>
      <div class="offer__form">
        <callback-input
          :data="{ type: 'sale', form: 'cars' }"
          :form_class="'offer-form'"
          button_theme="button_theme_bordered_black"
          input_theme="transparent"
          v-on="$listeners"
        >
          Получить предложение
        </callback-input>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "@/common/mixin";
import CallbackInput from "./callback-form/callback-input";

export default {
  name: "block-offer",
  components: { CallbackInput },
  mixins: [Mixin],
  data() {
    return {
      offer_list: [
        {
          title: "Кредитная ставка",
          value: "от 14,5%",
        },
        {
          title: "Гарантия",
          value: "2 года",
        },
        {
          title: "Бонус по трейд-ин",
          value: "до 380 000 ₽",
        },
      ],
    };
  },
  methods: {
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.offer {
  background-image: url("../images/bg/bg-offer.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #fff;
  padding: 115px 0;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__title {
    font-family: "AudiTypeExt";
    font-size: calcFontSize(18, 30, 320, 1920);
    text-align: center;
  }

  &__subtitle {
    font-size: calcFontSize(14, 18, 320, 1920);
    margin: 30px 0 60px 0;
    text-align: center;
  }

  &__list {
    width: 100%;
    max-width: 550px;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 80px;
  }

  &__list-item {
    text-align: center;

    p {
      color: #999999;
    }

    h4 {
      font-size: 24px;
    }
  }

  &__form {
    max-width: 350px;
  }
}

@media (max-width: 560px) {
  .offer {
    padding: 30px 0 35px 0;

    &__subtitle {
      margin: 30px 0;
    }

    &__list {
      flex-direction: column;
      margin-bottom: 40px;
    }

    &__list-item {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
